const breadcrumb = {

    Level1: {
        text: "Remittance App",
        href: "#",
        onClick: (e: any) => {
            e.preventDefault();
        },
    }
    ,
    Level2: {
        text: "Transfer Orders",
        href: "#",
        onClick: (e: any) => {
            e.preventDefault();
        },
    }
    ,
    Level3: {
        text: '',
    }
    ,
    Level4: {
        text: "Edit",
    }
    ,
};

export const getEditModeBreadcrumbs = (orderId: string): any[] => {
    let navigation = [];
    if (orderId)
        navigation.push(breadcrumb.Level1, breadcrumb.Level2, {text: `${orderId}`}, breadcrumb.Level4);
    else
        navigation.push(breadcrumb.Level1, breadcrumb.Level2, {text: `Create`});
    return navigation;
}

export const getOrderFormTitle = (orderId: string): any => {
    let title: any;

    if (orderId)
        title = `Transfer Order - ${orderId}`;
    else
        title = 'New Transfer Order';
    return title;
}
